var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDowntrend({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.69038C0 1.63999 0.653787 0.986206 3.70418 0.986206H7.45298C10.5034 0.986206 11.1572 1.63999 11.1572 4.69038V8.43919C11.1572 11.4896 10.5034 12.1434 7.45298 12.1434H3.70418C0.653787 12.1434 0 11.4896 0 8.43919V4.69038Z",
    fill: "#E66A62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61264 6.85535L5.57878 8.88921L3.54492 6.85535M7.61264 4.53094L5.57878 6.5648L3.54492 4.53094",
    stroke: "white",
    strokeWidth: 0.697323,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDowntrend);
export default __webpack_public_path__ + "static/media/downtrend.5ec477b27c6f17249eb7168dde66b586.svg";
export { ForwardRef as ReactComponent };